import React from 'react'
import styled from "styled-components"
import { HashLink as Link} from "react-router-hash-link";
// import Homebanner from "../../../components/Homebanner/Homebanner"
// import Ourstory from "../../../components/Ourstory/Ourstory"
// import WhyChooseAdaya from "../../../containers/chooseAdaya/ChooseAdaya"
// import ContactUs from "../../../components/Footerdesign/Bottom"

const Ul = styled.ul`
    display: flex;
    list-style: none;
    flex-flow: row nowrap;
    z-index:100;

    li {
        padding: 0.6em 1em;
        font-weight: 800;
        font-size: 1.5em;
      cursor:pointer;
      }

     li:hover{
        background-color:#56AB46;
        color:white;
      }
      li:checked{
        background-color:#56AB46;
        color:white;
      }

      a:hover{
        color: white;
      }

      @media (max-width:768px){
          display:none;
    `
   

export default function NavMenu() {

return(
  <>
  <Ul >
    <Link smooth to="#home">
      <li>Home</li>
    </Link>
    <Link smooth to="#ourstory">
      <li>Story</li>
    </Link>
    <Link smooth to="#whyus">
      <li>Why Us</li>
    </Link>
    <Link smooth to="#contacts">
      <li>Contact Us</li>
    </Link>
  </Ul>
  </>
)
}


